import { Image } from '@silvertours/common-landingpages-view';
import { MediaLegacy } from '@silvertours/front-legacy-shared';
import { SearchForm } from '../SearchForm';
import {
  BackgroundImage,
  MobileSearchContainer,
  SearchFormContainer,
} from './NewSearch.styles';
import { StageContentContainer } from './Stage.styles';

type Props = {
  image: MediaLegacy.ImageProps | Image;
};

const NewSearchContainer = ({ image }: Props) => {
  const action = () => {
    // TODO: Show wizard (on mobile)
  };

  return (
    <MobileSearchContainer>
      <BackgroundImage
        {...image}
        id="stage-image-mobile"
        fill
        priority
        style={{
          objectFit: 'cover',
        }}
      />
      <StageContentContainer>
        <SearchFormContainer>
          <SearchForm searchAction={action} />
        </SearchFormContainer>
      </StageContentContainer>
    </MobileSearchContainer>
  );
};

export { NewSearchContainer };
